import React from 'react';
import AddLeaderboardForm from './AddLeaderboardForm'
import { Modal } from 'reactstrap';

const AddLeaderboardModal = ({program, organization, isOpen, setLeaderboard, toggle}) => {

  const props = {
    program,
    organization,
    setLeaderboard,
    toggle
  };

  return (
    <Modal className="program-settings manager-program-settings-modal modal-xl" isOpen={isOpen} toggle={toggle}>
      <div className="manager-program-settings-modal__layout">
        <div className="manager-program-settings-modal__main">
          <div className="manager-program-settings-modal__header">
            <div className="manager-program-settings-modal__header-copy">
              <h3 className="manager-program-settings-modal__title">Add New Leaderboard</h3>
              <p className="manager-program-settings-modal__subtitle">
                Create a leaderboard and define its active window.
              </p>
            </div>
            <button
              type="button"
              className="manager-program-settings-modal__close"
              onClick={toggle}
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div className="manager-program-settings-modal__body">
            <AddLeaderboardForm {...props} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AddLeaderboardModal;
